export const INIT_PERSON = 'person/INIT_PERSON'
export const UNSET_PERSON = 'person/UNSET_PERSON'
export const UPDATE_BROKER_ID = 'person/UPDATE_BROKER_ID';
export const CANCEL_IMPERSONATION = 'person/CANCEL_IMPERSONATION';

export const unsetPerson = () => ({
    type: UNSET_PERSON,
})

export const initPerson = payload => ({
    type: INIT_PERSON,
    payload,
})

export const impersonateBrokerId = brokerId => {
    return {
        type: UPDATE_BROKER_ID,
        value: { brokerId }
    };
};

export const cancelImpersonation = () => {
    return {
        type: CANCEL_IMPERSONATION
    };
};
